import { useState, useEffect, useRef, useCallback } from "react";

import { format, addDays, differenceInDays } from "date-fns";
import flatpickr from "flatpickr";
import { getPropertyList } from "../../Redux/Slices/BON-Frontend/propertyListSlice";
import { AgentDashboRoomInventory } from "../../Services/Service";

export const AgentRoomInventoryCal = () => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selectedPropertyID, setSelectedPropertyID] = useState("");
   const [agentproperty, setAgentproperty] = useState([]);
  const [roomData, setRoomData] = useState({});
  const [bookingData, setBookingData] = useState([]);
  const [cancelCodes, setCancelCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedDates, setSelectedDates] = useState(() => {
    const today = new Date();
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push(addDays(today, i));
    }
    return days;
  });


  //  Init flatpickr
  useEffect(() => {
    flatpickr(inputRef.current, {
      mode: "range",
      dateFormat: "d M Y",
      defaultDate: [selectedDates[0], selectedDates[selectedDates.length - 1]],
      onChange: function (selectedDatesArray) {
        if (selectedDatesArray.length === 2) {
          const start = selectedDatesArray[0];
          const end = selectedDatesArray[1];
          const daysDiff = differenceInDays(end, start);
          const daysArray = [];
          for (let i = 0; i <= daysDiff; i++) {
            daysArray.push(addDays(start, i));
          }
          setSelectedDates(daysArray);
        }
      },
    });
  }, []);

  const propertyID = localStorage.getItem("AgentPropertyID");

  useEffect(() => {
    const fetchInventory = async () => {
      if (selectedDates.length < 2) return;

      const start = format(selectedDates[0], "yyyy-MM-dd");
      const end = format(selectedDates[selectedDates.length - 1], "yyyy-MM-dd");

      try {
        setLoading(true);
        setRoomData([]);
        const data = await AgentDashboRoomInventory(
          start,
          end,
          propertyID,
        );

        const grouped = {};
        data.forEach((item) => {
          const dateStr = format(new Date(item.Date), "yyyy-MM-dd");
          if (!grouped[item.RoomTypeCode]) grouped[item.RoomTypeCode] = {};
          grouped[item.RoomTypeCode][dateStr] = item.Count;
        });

        setRoomData(grouped);
      } catch (err) {
        console.error("Error fetching inventory:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchInventory();
  }, [selectedDates, selectedPropertyID]);

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center mb-0">
              <h5 className="card-title ">Total Available Room's</h5>
              {/* <!-- Check in & check out --> */}
              <div className="d-flex">
                <i class="fas fa-calendar fs-3 me-2 mt-2"></i>
                <div class="form-control-border form-control-transparent form-fs-md">
                  <input
                    type="text"
                    class="form-control flatpickr"
                    data-mode="range"
                    placeholder="Select date"
                    ref={inputRef}
                    style={{ width: "17rem", marginTop: "-2px" }}
                  />
                </div>
              </div>
            </div>

            <div className="card-body availability-table-wrapper">
              <table className="table table-bordered availability-table ">
                <thead>
                  <tr>
                    <th className="text-start" style={{ width: "357px" }}>
                      Room Type
                    </th>

                    {selectedDates.map((d, i) => (
                      <th key={i}>{format(d, "MMM d")}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(roomData).map((roomType, idx) => (
                    <tr key={idx}>
                      <td className="fw-bold text-start">{roomType}</td>
                      {selectedDates.map((d, i) => {
                        const dateStr = format(d, "yyyy-MM-dd");
                        const count = roomData[roomType][dateStr] || 0;
                        return (
                          <td key={i}>
                            {count === 0 ? (
                              <span className="badge bg-danger">0</span>
                            ) : (
                              count
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
